import React from 'react';

const noop = () => {};

export const MobileDrawerContext = React.createContext({
  isOpen: false,
  mode: 'navigation',
  contextualKey: null,
  registerContextualDrawer: noop,
  unregisterContextualDrawer: noop,
  openDrawer: noop,
  closeDrawer: noop
});

export const useMobileDrawer = () => React.useContext(MobileDrawerContext);
